import RatePlan from 'containers/Administration/RatePlan';
import BuyCredit from 'containers/Administration/BuyCredit';
import UserCredits from 'containers/Administration/UserCredits';
import Integration from 'containers/Administration/Integration';

export default [
  {
    name: 'buyCredit',
    component: BuyCredit,
    path: '/buy-credit',
    icon: 'far fa-credit-card',
    layout: '/out/administration',
  },
  {
    name: 'usersCredits',
    component: UserCredits,
    path: '/users-credits',
    icon: 'fa fa-users',
    layout: '/out/administration',
  },
  {
    name: 'ratePlans',
    component: RatePlan,
    path: '/rate-plans',
    icon: 'fas fa-sync-alt',
    layout: '/out/administration',
  },
  {
    name: 'integrations',
    component: Integration,
    path: '/integrations',
    icon: 'fa fa-puzzle-piece',
    layout: '/out/administration',
  },
];
